import * as React from "react";
import classnames from "classnames";
import styles from "./Page.module.scss";

interface Props {
    children: React.ReactNode;
    className?: string;
}

const Primary: React.FC<Props> = ({children, className}) => (
    <div className={classnames(styles.primary, className)}>
        {children}
    </div>
);

export default Primary;
